var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInj(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3334_32762)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1609 23.3401C15.1023 23.2801 15.0438 23.2201 14.9852 23.2201C13.6389 22.9201 12.2926 22.4401 11.1218 21.7201C8.66329 20.2201 7.02427 18.0001 6.96573 15.4201C6.96573 14.4601 7.14134 13.5001 7.5511 12.6001C7.78524 12.0001 9.19012 9.96012 9.36573 9.60012C10.3023 8.10012 10.0096 8.22012 8.66329 6.36012L6.79012 3.54012L5.56085 1.62012C4.85841 2.10012 4.15597 2.70012 3.51207 3.30012C2.22427 4.62012 1.22915 6.30012 0.643779 8.10012C0.0584134 9.90012 -0.117196 11.8201 0.11695 13.6801C0.351096 15.5401 1.05354 17.3401 2.10719 18.9001C3.16085 20.4601 4.56573 21.7801 6.14622 22.6801C1.99012 19.5601 0.0584134 14.8201 1.6389 10.0801C2.04866 8.82012 2.69256 7.62012 3.51207 6.54012L4.85841 8.58012C4.91695 8.70012 4.97549 8.82012 4.97549 9.00012C4.97549 9.12012 4.91695 9.30012 4.85841 9.42012C4.21451 10.2601 3.68768 11.1601 3.33646 12.1801C1.58036 17.4001 6.32183 22.8001 11.2974 23.7001C12.234 23.8801 13.9901 24.0601 14.9267 23.8201C14.9852 23.8201 15.0438 23.7601 15.0438 23.7601C15.1023 23.7001 15.1023 23.7001 15.1023 23.6401C15.1023 23.5801 15.1023 23.5201 15.1023 23.4601C15.2194 23.4601 15.2194 23.4001 15.1609 23.3401Z",
    fill: "url(#paint0_linear_3334_32762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.83881 0.659884C8.89735 0.719884 8.95588 0.779884 9.01442 0.779884C10.3608 1.07988 11.7071 1.55988 12.8778 2.27988C15.3364 3.77988 16.9754 5.99988 17.0339 8.57988C17.0339 9.53988 16.8583 10.4999 16.4486 11.3999C16.2144 11.9999 14.8095 14.0399 14.6339 14.3999C13.6973 15.8999 13.99 15.7799 15.3364 17.6399L17.2095 20.4599L18.4973 22.3799C19.1998 21.8999 19.9022 21.2999 20.5461 20.6999C21.8339 19.3799 22.8291 17.6999 23.4144 15.8999C23.9998 14.0999 24.1754 12.1799 23.9412 10.3199C23.7071 8.45988 23.0047 6.65988 21.951 5.09988C20.8973 3.53988 19.4925 2.21988 17.912 1.31988C22.0681 4.43988 23.9998 9.17988 22.3608 13.9199C21.951 15.1799 21.3071 16.3799 20.4876 17.4599L19.1412 15.4199C19.0827 15.2999 19.0242 15.1799 19.0242 14.9999C19.0242 14.8799 19.0827 14.6999 19.1412 14.5799C19.7852 13.7399 20.312 12.8399 20.6632 11.8199C22.4193 6.59988 17.6778 1.19988 12.7022 0.299884C11.7656 0.119884 10.0095 -0.0601157 9.07296 0.179884C9.01442 0.179884 8.95588 0.239884 8.95588 0.239884C8.83881 0.239884 8.78027 0.299884 8.78027 0.359884C8.78027 0.419884 8.78027 0.479884 8.78027 0.539884C8.78027 0.539884 8.78027 0.599884 8.83881 0.659884Z",
    fill: "url(#paint1_linear_3334_32762)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3334_32762",
    x1: 4.48676,
    y1: 21.7379,
    x2: 13.5837,
    y2: 6.3647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#174E5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#195A6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#1E779A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#27A7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#2ABAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#1DDAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EFFE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3334_32762",
    x1: 19.5145,
    y1: 2.26254,
    x2: 10.4169,
    y2: 17.6345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#174E5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#195A6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#1E779A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#27A7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#2ABAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#1DDAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EFFE0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3334_32762"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInj);
export default __webpack_public_path__ + "static/media/inj.92d8056e62e3fd9da38641ab8e398e68.svg";
export { ForwardRef as ReactComponent };